import styled from '@emotion/styled';

const ButtonGroup = styled.div`
  display: flex;
  justify-content: end;
  gap: 16px;
`;

export default ButtonGroup;
